import router from '@/router'

const fb = require('../../../config/firebase.js')

const state = () => ({
    currentUser: null,
    userProfile: {},
    userProfileLoaded: false,
})

const getters = {
    isAdmin: (state, getters) => {
        return state.userProfile.is_administrator;
    }
}

const actions = {
    clearData({ commit }) {
        commit('setCurrentUser', null)
        commit('setUserProfile', {})
    },
    fetchUserProfile({ commit, state }) {
        fb.usersCollection.doc(state.currentUser.uid)
            .get()
            .then(res => {
                commit('setUserProfile', res.data())
                commit('setUserProfileLoaded', true)
            })
            .catch(err => {
                console.log(err)
            })
    },
    loadUserAndWatchForChanges({ commit, state }) {
        let vm = this;
        fb.auth.onAuthStateChanged(userData => {
            if (userData) {
                commit('setCurrentUser', {
                    uid: userData.uid,
                    displayName: userData.displayName,
                    photoUrl: userData.photoURL,
                    email: userData.email
                });
                vm.dispatch('user/fetchUserProfile');
                fb.usersCollection.doc(userData.uid).onSnapshot(doc => {
                    commit('setUserProfile', doc.data())
                    if(doc.data() != null) {
                        if(doc.data().is_account_banned === true) router.push('Banned');
                        else if(doc.data().is_account_suspended === true) router.push('Suspended');
                        else if(doc.data().is_account_in_deletion_mode === true) router.push('Deletion');
                        //else router.push('Dashboard');
                    }
                })
            }
        })
    }
}

const mutations = {
    setCurrentUser(state, val) {
        state.currentUser = val;
    },
    setUserProfile(state, val) {
        state.userProfile = val;
    },
    setUserProfileLoaded(state, val) {
        state.userProfileLoaded = val;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/stores/modules/global/user.js